<template>
  <div>
    <v-card color="#EDF1F3">
      <v-layout align-center justify-start style="padding-inline-start: 20px">
        <loading-component :value="loading" />
        <v-form ref="form">
          <img :src="api.GET_IMAGE(transferCenter.profile_image)" class="image" v-if="transferCenter" />
        </v-form>

        <v-flex xs3>
          <div class="headline">
            {{ transferCenter.name }}
          </div>
          <div style="color: #8599a3">{{ transferCenter.email }}</div>
          <div  style="color: #8599a3; margin-top: 6px">
            {{ transferCenter.phone_number }}
          </div>
        </v-flex>

        <v-flex xs2>
          <v-switch v-model="disabledSwitch"
            :label='disabledSwitch ? $t("transferCentersPage.unblock") : $t("transferCentersPage.block")'
            @change="changeDisabledStatus" color="red"></v-switch>
        </v-flex>
       
      </v-layout>
    </v-card>

    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab :key="1" ripple active-class="tab"> {{ $t("transferCentersPage.tabTransferCenter") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <v-card height="100%" style="height: 100%; position: absolute; width: 100%">
          <v-layout align-center>
            <v-flex xs6 style="height: 100%; margin-inline-start: 100px">
              <v-card-title primary-title>
                <v-flex xs12 style="margin-bottom: 25px">
                  <div class="headline">{{ $t("transferCentersPage.information") }}</div>
                </v-flex>
                <table>
                  <tr>
                    <th>{{ $t("transferCentersPage.id") }}</th>
                    <td>
                      <span>{{ transferCenter.id }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("transferCentersPage.name") }}</th>
                    <td>
                      <v-text-field v-model="editHolder.name_value" style="float: inline-start"
                        :label='$t("transferCentersPage.name")'
                        :disabled="!this.editHolder.name"
                        :rules='[(val) => !!val || $t("transferCentersPage.required")]'>
                      </v-text-field>
                      <button @click="editHolder.name = true" v-if="!this.editHolder.name">
                        <v-icon>edit</v-icon>
                      </button>
                      <button @click="
                        editHolder.name = false;
                      editHolder.name_value = transferCenter.name;
                      " v-if="this.editHolder.name">
                        <v-icon>close</v-icon>
                      </button>
                      <button @click="editHolder.name = false" v-if="this.editHolder.name">
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>
                
                  <tr>
                    <th>{{ $t("transferCentersPage.phoneNumber") }}</th>
                    <td>
                      <v-text-field v-model="editHolder.phone_number_value" style="float: inline-start"
                        :label='$t("transferCentersPage.phoneNumber")'
                        :disabled="!this.editHolder.phone_number"
                        :rules='[(val) => !!val || $t("transferCentersPage.required")]'>
                      </v-text-field>
                      <button @click="editHolder.phone_number = true" v-if="!this.editHolder.phone_number">
                        <v-icon>edit</v-icon>
                      </button>
                      <button @click="
                        editHolder.phone_number = false;
                      editHolder.phone_number_value = transferCenter.phone_number;
                      " v-if="this.editHolder.phone_number">
                        <v-icon>close</v-icon>
                      </button>
                      <button @click="editHolder.phone_number = false" v-if="this.editHolder.phone_number">
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>

                  <tr>
                    <th>{{ $t("transferCentersPage.email") }}</th>
                    <td>
                      <v-text-field v-model="editHolder.username_value" style="float: inline-start"
                        :label='$t("transferCentersPage.email")'
                        :disabled="!this.editHolder.username"
                        :rules='[(val) => !!val || $t("transferCentersPage.required"), (val) => /.+@.+\..+/.test(val) || $t("transferCentersPage.invalidEmail")]'>
                      </v-text-field>
                      <button @click="editHolder.username = true" v-if="!this.editHolder.username">
                        <v-icon>edit</v-icon>
                      </button>
                      <button @click="
                        editHolder.username = false;
                      editHolder.username_value = transferCenter.username;
                      " v-if="this.editHolder.username">
                        <v-icon>close</v-icon>
                      </button>
                      <button @click="editHolder.username = false" v-if="this.editHolder.username">
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>

                  <tr>
                    <th>{{ $t("transferCentersPage.address") }}</th>
                    <td>
                      <v-textarea v-model="editHolder.address_value" style="float: inline-start"
                        :label='$t("transferCentersPage.address")'
                        :disabled="!this.editHolder.address"
                        :rules='[(val) => !!val || $t("transferCentersPage.required")]'
                        rows="3" auto-grow>
                      </v-textarea>
                      <button @click="editHolder.address = true" v-if="!this.editHolder.address">
                        <v-icon>edit</v-icon>
                      </button>
                      <button @click="
                        editHolder.address = false;
                      editHolder.address_value = transferCenter.address;
                      " v-if="this.editHolder.address">
                        <v-icon>close</v-icon>
                      </button>
                      <button @click="editHolder.address = false" v-if="this.editHolder.address">
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("transferCentersPage.governorate") }}</th>
                    <td>
                      <v-select v-model="editHolder.governorate_id_value" style="float: inline-start"
                        :label='$t("transferCentersPage.governorate")'
                        :items="governorateItems" item-text="name" item-value="id" clearable
                        :disabled="!this.editHolder.governorate">
                      </v-select>
                      <button @click="editHolder.governorate = true" v-if="!this.editHolder.governorate">
                        <v-icon>edit</v-icon>
                      </button>
                      <button @click="
                        editHolder.governorate = false;
                      editHolder.governorate_id_value = transferCenter.governorate_id || null;
                      " v-if="this.editHolder.governorate">
                        <v-icon>close</v-icon>
                      </button>
                      <button @click="editHolder.governorate = false" v-if="this.editHolder.governorate">
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("transferCentersPage.accountStatus") }}</th>
                    <td>
                      <span>
                        {{
                          transferCenter.blacklisted_at
                            ? $t("transferCentersPage.inactive")
                            : $t("transferCentersPage.active")
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("transferCentersPage.balance") }}</th>
                    <td>
                      <span>
                        {{
                          transferCenter.balance | money
                        }}
                      </span>
                    </td>
                  </tr>
                  <!-- Accountant doc 2026-10-03 item 1.9: the company's own
                       (Snap) center and its separate gift budget. -->
                  <tr>
                    <th>{{ $t("snapCenterGifts.isCompany") }}</th>
                    <td>
                      <v-switch v-model="companySwitch" color="primary" hide-details
                        :label='companySwitch ? $t("snapCenterGifts.yes") : $t("snapCenterGifts.no")'
                        :disabled="companySaving" @change="changeCompanyStatus"></v-switch>
                    </td>
                  </tr>
                  <tr v-if="transferCenter && (transferCenter.is_company || transferCenter.gift_balance)">
                    <th>{{ $t("snapCenterGifts.giftBalance") }}</th>
                    <td>
                      <span>{{ transferCenter.gift_balance | money }}</span>
                      <!-- The gift-budget endpoint requires ACCOUNTING. -->
                      <v-btn small color="primary" v-if="transferCenter.is_company && canManageGiftBudget" @click="openGiftDialog">
                        {{ $t("snapCenterGifts.addGiftBudget") }}
                      </v-btn>
                    </td>
                  </tr>
                
                  <tr>
                    <th>{{ $t("transferCentersPage.creationDate") }}</th>
                    <td>
                      <span>
                        {{
                          $companyTime(
                            transferCenter.created_at,
                            "DD-MM-YYYY HH:mm"
                          )
                        }}
                      </span>
                    </td>
                  </tr>
                </table>
              </v-card-title>
            </v-flex>

            <v-flex xs5 style="padding: 16px">
              <div class="map-label">{{ $t("transferCentersPage.location") }}</div>
              <div id="location-map"></div>
            </v-flex>
          </v-layout>
          <v-btn @click="save" :loading="loading" style="float: inline-end" color="primary"
            :disabled="disableSaveButton">{{ $t("transferCentersPage.save") }}</v-btn>
        </v-card>
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="2" ripple> {{ $t("transferCentersPage.tabAdminTransfers") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <DataTable :url="`transfer-center/${$route.params.id}/admin-transfers`" :sortable="true" :enable-edit="false"
            :enable-add="false" :enable-delete="false" :formatter="formatters" :actions-extra-main="actionsExtraMain"
            :fields-hidden-main="[]" :titles="adminTransfersTitles" />
        </div>
      </v-tab-item>

        <v-tab active-class="tab" :key="3" ripple> {{ $t("transferCentersPage.tabCaptainsTransfers") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <DataTable :url="`transfer-center/${$route.params.id}/captain-transfers`" :sortable="true" :enable-edit="false"
            :enable-add="false" :enable-delete="false" :formatter="formatters" :actions-extra-main="actionsExtraMain"
            :fields-hidden-main="[]" :titles="captainTransfersTitles" />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="4" ripple> {{ $t("snapCenterGifts.tabGiftMovements") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <DataTable :key="giftMovementsKey" :url="`transfer-center/${$route.params.id}/gift-movements`" :sortable="false"
            :disable-search="true" :enable-edit="false" :enable-add="false" :enable-delete="false"
            :formatter="giftFormatters" :actions-extra-main="actionsExtraMain"
            :fields-hidden-main="['recipient_type']" :titles="giftMovementsTitles" />
        </div>
      </v-tab-item>
    </v-tabs>

    <v-dialog v-if="canManageGiftBudget" v-model="giftDialog" max-width="480px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("snapCenterGifts.dialogTitle") }}</span>
        </v-card-title>
        <v-card-text>
          <p class="gift-hint">{{ $t("snapCenterGifts.dialogHint") }}</p>
          <div class="gift-current">
            {{ $t("snapCenterGifts.currentBalance") }}:
            <b>{{ (transferCenter ? transferCenter.gift_balance : 0) | money }}</b>
          </div>
          <v-form ref="giftForm" :key="giftFormKey">
            <v-text-field v-model="giftForm.amount" type="number" :label='$t("snapCenterGifts.amount")'
              :rules="[giftAmountRule]"></v-text-field>
            <v-textarea v-model="giftForm.notes" :label='$t("snapCenterGifts.notes")' rows="2" auto-grow></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="giftDialog = false">{{ $t("snapCenterGifts.cancel") }}</v-btn>
          <v-btn flat color="red" :loading="giftSaving" @click="submitGiftBudget(-1)">
            {{ $t("snapCenterGifts.reduce") }}
          </v-btn>
          <v-btn color="primary" :loading="giftSaving" @click="submitGiftBudget(1)">
            {{ $t("snapCenterGifts.add") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LoadingComponent from "@/components/LoadingComponent";
import StatusToggle from "@/components/monaco/input/StatusToggle";
import DataTable from "@/components/monaco/DataTable";
import { companyToday, formatCompanyTime } from "@/util/companyTime";
import Mapbox from "mapbox-gl";

export default {
  name: "TransferCenterProfile",
  title() {
    return this.$t("transferCentersPage.profileTitle");
  },
  components: {
    LoadingComponent,
    StatusToggle,
    DataTable,
  },

  data() {
    return {
      registerLoading: false,
      transferCenter: null,
      loading: true,
      dialog: false,
      active: 0,
      disabledSwitch: false,
      companySwitch: false,
      companySaving: false,
      giftDialog: false,
      giftSaving: false,
      giftFormKey: 0,
      giftForm: { amount: null, notes: "" },
      giftMovementsKey: 0,
      map: null,
      marker: null,
      governorates: [],
      editHolder: {
        name: false,
        name_value: "",
        username: false,
        username_value: "",
        phone_number: false,
        phone_number_value: "",
        address: false,
        address_value: "",
        location_value: null,
        governorate: false,
        governorate_id_value: null,
      },
    };
  },
  mounted() {
    this.axios.get(`transfer-center/${this.$route.params.id}`).then(({ data }) => {
      this.transferCenter = data.data;
      this.editHolder.name_value = data.data.name;
      this.editHolder.username_value = data.data.username;
      this.editHolder.phone_number_value = data.data.phone_number;
      this.editHolder.address_value = data.data.address;
      this.editHolder.location_value = data.data.location
        ? [...data.data.location.coordinates]
        : null;
      this.editHolder.governorate_id_value = data.data.governorate_id || null;
      this.disabledSwitch = !!this.transferCenter.blacklisted_at;
      this.companySwitch = !!this.transferCenter.is_company;
      this.loading = false;
      console.log("transferCenter");
      console.log(this.transferCenter);
      this.$nextTick(() => this.loadMap());
    });

    this.axios
      .get(this.api.ACTIONS.GOVERNORATE || "governorate")
      .then((response) => {
        this.governorates = response.data.data;
      })
      .catch((error) => {
        this.governorates = [];
        console.warn("governorate list unavailable", error);
      });
  },
  methods: {
    openImage(value) {
      // console.log(value);
      window.open(this.api.GET_IMAGE(value.path), "_blank");
    },
    loadMap() {
      Mapbox.accessToken = this.api.mapBox.accessToken;
      const initialCoords = this.transferCenter.location
        ? this.transferCenter.location.coordinates
        : this.api.mapBox.center;
      this.map = new Mapbox.Map(
        Object.assign({ container: "location-map" }, this.api.mapBox, {
          center: initialCoords,
        })
      );
      this.marker = new Mapbox.Marker({ draggable: true });
      this.marker.setLngLat(initialCoords);
      this.marker.addTo(this.map);
      this.marker.on("dragend", () => {
        const lngLat = this.marker.getLngLat();
        this.editHolder.location_value = [lngLat.lng, lngLat.lat];
      });
    },
    governorateChanged() {
      const orig = (this.transferCenter && this.transferCenter.governorate_id) || null;
      const next = this.editHolder.governorate_id_value || null;
      return orig !== next;
    },
    locationChanged() {
      const orig = this.transferCenter && this.transferCenter.location
        ? this.transferCenter.location.coordinates
        : null;
      const next = this.editHolder.location_value;
      if (!orig && !next) return false;
      if (!orig || !next) return true;
      return orig[0] !== next[0] || orig[1] !== next[1];
    },
    save() {
      let updatedInfo = {};

      if (
        this.editHolder.name_value &&
        this.editHolder.name_value != this.transferCenter.name
      )
        updatedInfo["name"] = this.editHolder.name_value;
      else delete updatedInfo["name"];

      if (
        this.editHolder.username_value &&
        this.editHolder.username_value != this.transferCenter.username
      )
        updatedInfo["username"] = this.editHolder.username_value;
      else delete updatedInfo["username"];

      if (
        this.editHolder.phone_number_value &&
        this.editHolder.phone_number_value != this.transferCenter.phone_number
      )
        updatedInfo["phone_number"] = this.editHolder.phone_number_value;
      else delete updatedInfo["phone_number"];

      if (
        this.editHolder.address_value &&
        this.editHolder.address_value != this.transferCenter.address
      )
        updatedInfo["address"] = this.editHolder.address_value;
      else delete updatedInfo["address"];

      const locationDirty = this.locationChanged();
      if (locationDirty && this.editHolder.location_value) {
        updatedInfo["location"] = {
          type: "Point",
          coordinates: this.editHolder.location_value,
        };
      }

      const governorateDirty = this.governorateChanged();
      if (governorateDirty)
        updatedInfo["governorate_id"] = this.editHolder.governorate_id_value || null;

      if (
        this.editHolder.name_value == "" ||
        this.editHolder.username_value == "" ||
        this.editHolder.phone_number_value == "" ||
        this.editHolder.address_value == ""
      )
        return;

      if (
        this.editHolder.username_value == this.transferCenter.username &&
        this.editHolder.name_value == this.transferCenter.name &&
        this.editHolder.phone_number_value == this.transferCenter.phone_number &&
        this.editHolder.address_value == this.transferCenter.address &&
        !locationDirty &&
        !governorateDirty
      )
        return;

      this.axios
        .put(`transfer-center/${this.$route.params.id}`, updatedInfo)
        .then(() => {
          this.transferCenter.username = this.editHolder.username_value;
          this.transferCenter.name = this.editHolder.name_value;
          this.transferCenter.phone_number = this.editHolder.phone_number_value;
          this.transferCenter.address = this.editHolder.address_value;
          if (locationDirty && this.editHolder.location_value) {
            this.transferCenter.location = {
              type: "Point",
              coordinates: [...this.editHolder.location_value],
            };
          }
          if (governorateDirty) {
            this.transferCenter.governorate_id =
              this.editHolder.governorate_id_value || null;
          }
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("transferCentersPage.savedToast"),
            "green"
          );
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", [
            "bottom",
            "left",
          ]);
        });
    },
    changeCompanyStatus(val) {
      const isCompany = !!val;
      this.$dialova({
        title: isCompany
          ? this.$t("snapCenterGifts.companyOnTitle")
          : this.$t("snapCenterGifts.companyOffTitle"),
        paragraph: isCompany
          ? this.$t("snapCenterGifts.companyOnConfirm")
          : this.$t("snapCenterGifts.companyOffConfirm"),
        loader: true,
      })
        .then(({ close }) => {
          this.companySaving = true;
          this.axios
            .put(`transfer-center/${this.$route.params.id}`, { is_company: isCompany })
            .then(({ data }) => {
              const saved = data && data.data;
              this.transferCenter.is_company = saved ? !!saved.is_company : isCompany;
              this.companySwitch = this.transferCenter.is_company;
              window.getApp.$emit("SHOW_TOAST", this.$t("snapCenterGifts.companyChangedToast"), "green");
            })
            .catch((err) => {
              this.companySwitch = !isCompany;
              const msg = (err.response && err.response.data && err.response.data.message) ||
                this.$t("snapCenterGifts.companyChangeFailed");
              window.getApp.$emit("SHOW_TOAST", msg, "red");
            })
            .finally(() => {
              this.companySaving = false;
              close();
            });
        })
        .catch(() => {
          // Dialog dismissed: put the switch back.
          this.companySwitch = !isCompany;
        });
    },
    openGiftDialog() {
      if (!this.canManageGiftBudget) return;
      this.giftForm = { amount: null, notes: "" };
      this.giftFormKey++;
      this.giftDialog = true;
    },
    giftAmountRule(v) {
      return (v !== null && v !== "" && Number(v) > 0) || this.$t("snapCenterGifts.amountInvalid");
    },
    submitGiftBudget(sign) {
      if (!this.$refs.giftForm.validate()) return;
      // The operator types new pounds; the backend stores old units (x100).
      const amount = this.toStoredAmount(Number(this.giftForm.amount) * sign);
      this.giftSaving = true;
      this.axios
        .post(`transfer-center/${this.$route.params.id}/gift-budget`, {
          amount,
          notes: this.giftForm.notes || null,
        })
        .then(({ data }) => {
          this.transferCenter.gift_balance = data.data.gift_balance;
          this.giftMovementsKey++;
          this.giftDialog = false;
          window.getApp.$emit("SHOW_TOAST", this.$t("snapCenterGifts.savedToast"), "green");
        })
        .catch((err) => {
          const msg = (err.response && err.response.data && err.response.data.message) ||
            this.$t("snapCenterGifts.failedToast");
          window.getApp.$emit("SHOW_TOAST", msg, "red");
        })
        .finally(() => {
          this.giftSaving = false;
        });
    },
    changeDisabledStatus(val) {
      const disabled = val ? 1 : 0;

      const title = val
        ? this.$t("transferCentersPage.blockAccount")
        : this.$t("transferCentersPage.unblockAccount");
      const paragraph = val
        ? this.$t("transferCentersPage.blockConfirm")
        : this.$t("transferCentersPage.unblockConfirm");

      this.$dialova({
        title,
        paragraph,
        loader: true,
      })
        .then(({ close }) => {
          // this.loading = true;
          this.axios
            .put(
              `transfer-center/${this.$route.params.id}/change_disabled_at_value`,
              { disabled }
            )
            .then(() => {
              this.transferCenter.blacklisted_at = disabled ? new Date().toISOString() : null;
              this.disabledSwitch = !!this.transferCenter.blacklisted_at;
              window.getApp.$emit(
                "SHOW_TOAST",
                disabled
                  ? this.$t("transferCentersPage.accountBlockedToast")
                  : this.$t("transferCentersPage.accountUnblockedToast"),
                "green"
              );
              close();
            })
            .catch(() => {
              // revert switch on error
              this.disabledSwitch = !val;
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("transferCentersPage.statusChangeFailed"),
                "red"
              );
              close();
            })
            .finally(() => {
              //  this.loading = false;
            });
        })
        .catch(() => {
          // user cancelled dialog -> revert switch
          this.disabledSwitch = !val;
        });
    }
  },
  computed: {
    // Funding or correcting the gift budget is an ACCOUNTING action on the
    // backend (POST transfer-center/{id}/gift-budget); a TRANSFER_CENTERS-only
    // user sees the budget but never the button that would only 403.
    canManageGiftBudget() {
      return this.hasPermission("ACCOUNTING");
    },
    today() {
      // Final-version doc 2026-10-05: the company date, not the PC's.
      return companyToday();
    },

    disableSaveButton() {
      const orig = this.transferCenter && this.transferCenter.location
        ? this.transferCenter.location.coordinates
        : null;
      const next = this.editHolder.location_value;
      const locationSame =
        (!orig && !next) ||
        (orig && next && orig[0] === next[0] && orig[1] === next[1]);
      return (
        this.editHolder.username_value == this.transferCenter.username &&
        this.editHolder.name_value == this.transferCenter.name &&
        this.editHolder.phone_number_value == this.transferCenter.phone_number &&
        this.editHolder.address_value == this.transferCenter.address &&
        locationSame &&
        (this.editHolder.governorate_id_value || null) ==
          (this.transferCenter.governorate_id || null)
      );
    },

    governorateItems() {
      return this.governorates.map((g) => ({
        id: g.id,
        name:
          (this.$i18n && this.$i18n.locale === "ar"
            ? g.name_ar || g.name_en
            : g.name_en || g.name_ar) || `#${g.id}`,
      }));
    },
   
    adminTransfersTitles() {
      return {
        id: "#",
        username: this.$t("transferCentersPage.userEmail"),
        user_full_name: this.$t("transferCentersPage.userName"),
        amount: this.$t("transferCentersPage.amount"),
        created_at: this.$t("transferCentersPage.creationTime")
      };
    },
    captainTransfersTitles() {
      return {
        id: "#",
        captain_username: this.$t("transferCentersPage.driverPhoneNumber"),
        captain_full_name: this.$t("transferCentersPage.driverName"),
        captain_account_code: this.$t("transferCentersPage.driverAccountCode"),
        required_to_pay: this.$t("transferCentersPage.amount"),
        created_at: this.$t("transferCentersPage.creationTime")
      };
    },
    formatters() {
      const formatMoney = this.formatMoney;

      return {
        created_at(value) {
          return formatCompanyTime(value, "DD-MM-YYYY HH:mm");
        },
        amount(value) {
          return formatMoney(value);
        },
        required_to_pay(value) {
          return formatMoney(value);
        },
        captain_account_code(value) {
          return value === null || value === undefined || value === "" ? "-" : value;
        }
      };
    },
    actionsExtraMain() {
      return {};
    },
    giftMovementsTitles() {
      return {
        id: "#",
        type: this.$t("snapCenterGifts.type"),
        amount: this.$t("transferCentersPage.amount"),
        balance_after: this.$t("snapCenterGifts.balanceAfter"),
        accounting_id: this.$t("snapCenterGifts.operation"),
        recipient_kind: this.$t("snapCenterGifts.recipient"),
        recipient_id: this.$t("snapCenterGifts.recipientId"),
        notes: this.$t("snapCenterGifts.notes"),
        user_username: this.$t("snapCenterGifts.user"),
        created_at: this.$t("snapCenterGifts.date"),
      };
    },
    giftFormatters() {
      const formatMoney = this.formatMoney;
      const t = (key) => this.$t(key);
      const kinds = {
        captain: "snapCenterGifts.recipientCaptain",
        passenger: "snapCenterGifts.recipientPassenger",
        business: "snapCenterGifts.recipientBusiness",
      };
      const dash = (value) => (value === null || value === undefined || value === "" ? "-" : value);

      return {
        created_at(value) {
          return formatCompanyTime(value, "DD-MM-YYYY HH:mm");
        },
        amount(value) {
          return formatMoney(value);
        },
        balance_after(value) {
          return formatMoney(value);
        },
        type(value) {
          return value ? t(`snapCenterGifts.type${value}`) : "-";
        },
        recipient_kind(value) {
          return kinds[value] ? t(kinds[value]) : "-";
        },
        recipient_id: dash,
        accounting_id: dash,
        notes: dash,
        user_username: dash,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  background-color: #ffffff !important;
}

.docs:hover {
  cursor: pointer;
}

.star {
  color: #f3c220;
}

.image {
  border-radius: 100%;
  height: 100px;
  width: 100px;
  margin-inline-end: 17px;
  margin-top: 10px;
}

.image:hover {
  background-color: black;
  opacity: 0.5;
  border-radius: 100%;
  cursor: pointer;
}

.tab {
  color: #e21024 !important;
}

.active {
  border-style: solid;
  border-color: #e42235;
  border-width: thin;
}

.transferCenters-list {
  width: 100%;
  margin-inline-start: 90px;
  z-index: 7;
  max-height: 100px;
  min-height: 100px;
  float: inline-start;
  padding: 22px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ededed;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #788e98;
  }
}

.transferCenter {
  width: max-content;
  float: inline-start;
  font-size: 12pt;
  font-weight: normal !important;
  padding: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;
  cursor: pointer;

  img {
    height: 32px;
    width: 32px;
    float: inline-start;
    border-radius: 100%;
  }

  .name {
    color: #202731;
    width: max-content;
    overflow: hidden;
    min-width: 140px;
    max-width: 250px;
  }
}

.car {
  color: #7e939c;
}

.open {
  margin-bottom: 15px;
  margin-inline-start: 35px;
}

.constraints.v-label {
  font-size: xx-large !important;
}

table {
  max-width: 500px;
  width: 500px;

  tr {

    th,
    td {
      padding: 0 12px;
      text-align: start;

      span {
        padding: 16px 0;
        float: inline-start;
      }
    }

    th {
      padding-inline-start: 0;
    }

    td {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      gap: 14px;
      max-width: 350px;
      width: 350px;
    }
  }
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}

.map-label {
  font-size: 14px;
  color: #202731;
  margin-bottom: 8px;
}

.gift-hint {
  color: #5f6b72;
  font-size: 13px;
}

.gift-current {
  margin-bottom: 8px;
}

#location-map {
  width: 100%;
  height: 500px;
  border-radius: 8px;
}
</style>
